import { useState, useCallback } from 'react';

export default function useBoolean(defaultValue = false): {
  value: boolean;
  setValue: (value: boolean) => void;
  toggle: () => void;
  setTrue: () => void;
  setFalse: () => void;
} {
  const [value, setValue] = useState(defaultValue);

  const toggle = useCallback(() => setValue(!value), [value]);
  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);

  return {
    value,
    setValue,
    toggle,
    setTrue,
    setFalse,
  };
}
